import { Component, EventEmitter, Input, Output } from '@angular/core'
import { NgClass } from '@angular/common';

import { DateOnly } from '@nx-superprep/utils'

import { DrawerContentComponent } from './drawer-content/drawer-content.component'
import { DrawerHeaderComponent } from "./drawer-header/drawer-header.component"
import { ResponsiveComponent } from '@nx-superprep/shared'
import { HandlebarComponent } from "../handlebar/handlebar.component"
import { DrawerState } from './drawer';
import { isEmpty } from 'lodash-es'


@Component({
  selector: 'pop-ui-drawer',
  standalone: true,
  templateUrl: './drawer.component.html',
  styleUrls: ['./drawer.component.scss'],
  imports: [NgClass, DrawerContentComponent, DrawerHeaderComponent, HandlebarComponent]
})
export class DrawerComponent extends ResponsiveComponent {
  @Input()
  set date(value: DateOnly) {
    if (!this.state) { return }
    this.state.contentState.date = value
  }

  private _state!: DrawerState
  @Input()
  get state() { return this._state }
  set state(value) {
    this._state = value
    if (value?.contentState.selected) { this.stateChange.emit(this._state) }
  }
  @Output() stateChange = new EventEmitter<DrawerState>()
  @Output() handlebarAction = new EventEmitter<Event>()

  onHandlebarAction(e: Event) {
    this.handlebarAction.emit(e)
  }

  get headerState() { return this.state?.headerState ?? {} }
  set headerState(value) {
    if (!this._state) { return }
    this.state = {...this._state, headerState:value}
  }

  get isControlOnly() {
    return (this.state?.headerState?.title ?? '').length === 0 && (this.state?.headerState?.tabs ?? []).length > 0
  }

  get isHandlebarVisible() {
    return false;
    //return !this.isWeb && !['performance-stats','performance-charts'].includes(this.state.type)
  }

  override get rootClassName(): string { return `${super.rootClassName}${this.isFullScroll ? ' scrollable' : ''}`}

  isEmpty(arg0: unknown) {
    return isEmpty(arg0)
  }

}

export { DrawerState };

